// $lib/stickers.js
import { user } from '$lib/stores/store';
import { get } from 'svelte/store';
import { writable } from 'svelte/store';

import { persist } from '$lib/stores/face-store.js';
import ApiClient from '$lib/api';

const api = new ApiClient();

export const selectedStickerPack = persist('selectedStickerPack', 'recent');
export const recentStickers = persist('recentStickers', []);
export const stickerCache = writable({});
export const getStickerPacks = () => api.get('/api/stickers/sticker-packs');
export const getMyStickerPacks = () => api.get('/api/stickers/my-sticker-packs');
export const getStickers = (packId) => api.get(`/api/stickers/sticker-packs/${packId}/stickers`);
export const downloadPack = (packId) => api.post(`/api/stickers/sticker-packs/${packId}/download`);
export const savePackSort = (orders) => api.post('/api/stickers/my-sticker-packs/sort', { orders });
export const deletePack = (packId) => api.delete(`/api/stickers/my-sticker-packs/${packId}`);

export let recentPack = {
    id: 'recent',
    name: 'Gần đây',
    icon: '🕘',
    stickers: []
};

export function getRecentByUser() {
    const u = get(user);
    const map = get(recentStickers);
    return u && map[u.id] ? map[u.id] : [];
}

export function setRecentByUser(list) {
    const u = get(user);
    if (!u) return;

    recentStickers.update((map) => ({
        ...map,
        [u.id]: list
    }));
}